import { gql } from "generated-graphql";

export const MANIFEST_DOCUMENTS_QUERY = gql(`
  query ManifestDocuments($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    documents(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      count
      items {
        id
        title
        tenantId
        documentType
        fileExtension
        extractionStatus
        extractionError
        createdAt
        sourceWasteManifest {
          id
          manifestTrackingNumber
          generatorId
        }
        sourceProcessedManifest {
          id
          manifestTrackingNumber
          facility {
            id
            name
          }
        }
      }
    }
  }
`);
